import styled from "styled-components"
import NetworkAd from "components/network-ad"

export const NetworkAdUnit = styled(NetworkAd)`
  max-width: 120rem;
  margin: 0 auto;
  padding: 1.2rem 0 2.8rem;
  clear: both;
`
